import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["container", "template", "field", "addButton", "limitMessage"]
  static values = { max: { type: Number, default: 3 } }

  declare readonly containerTarget: HTMLElement
  declare readonly templateTarget: HTMLTemplateElement
  declare readonly fieldTargets: HTMLElement[]
  declare readonly addButtonTarget: HTMLButtonElement
  declare readonly limitMessageTarget: HTMLElement
  declare readonly maxValue: number

  private sequence = 0

  connect() {
    this.sequence = 0
    this.updateState()
  }

  add(event: Event) {
    event.preventDefault()
    if (this.activeFieldCount() >= this.maxValue) return

    const key = `new_${Date.now()}_${this.sequence++}`
    const displayOrder = this.availableDisplayOrder()
    const html = this.templateTarget.innerHTML
      .replaceAll("NEW_RECORD", key)
      .replaceAll("NEW_DISPLAY_ORDER", displayOrder.toString())

    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.updateState()
  }

  remove(event: Event) {
    event.preventDefault()
    const trigger = event.currentTarget as HTMLElement
    trigger.closest('[data-nested-fields-target="field"]')?.remove()
    this.updateState()
  }

  toggleDestroy(event: Event) {
    const checkbox = event.currentTarget as HTMLInputElement
    if (!checkbox.checked && this.activeFieldCount() > this.maxValue) {
      checkbox.checked = true
      this.limitMessageTarget.textContent = `窓口情報は最大${this.maxValue}件です。追加した窓口を削除してから元に戻してください。`
    }
    this.updateState()
  }

  activeFieldCount() {
    return this.fieldTargets.filter((field) => {
      const destroy = field.querySelector<HTMLInputElement>('input[name$="[_destroy]"]')
      return !destroy?.checked
    }).length
  }

  availableDisplayOrder() {
    const used = this.fieldTargets.filter((field) => {
      const destroy = field.querySelector<HTMLInputElement>('input[name$="[_destroy]"]')
      return !destroy?.checked
    }).map((field) => Number(field.dataset.displayOrder))

    return [1, 2, 3].find((displayOrder) => !used.includes(displayOrder)) || 3
  }

  updateState() {
    const atLimit = this.activeFieldCount() >= this.maxValue
    this.addButtonTarget.disabled = atLimit
    this.addButtonTarget.classList.toggle("opacity-50", atLimit)
    this.addButtonTarget.classList.toggle("cursor-not-allowed", atLimit)
    this.limitMessageTarget.textContent = atLimit ? `最大${this.maxValue}件まで登録されています。` : ""
  }
}
